<template>
	<div class="user-login-index">
		<div class="login">
			<div class="login_content">
				<div class="login_content_left">
					<div class="login-qr-service">
						<img class="qr-img" src="http://img-dbzd.doubaozhidao.com/20231109/1699523560302001.png" alt="kefu">
						<p class="qr-text">客服二维码</p>
					</div>
				</div>
				<div class="login_content_right">
					<div class="login_content_header">
						<div class="login_content_header_img">
							<img src="https://img-dbzd.doubaozhidao.com/wisdomhtml/20241217_1709_loginWhiteLogo.png" alt="豆包知道" />
						</div>
						<p class="login_content_header_tit">欢迎进入豆包泛知道讲师端管理系统</p>
					</div>
					<el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px"
						class="login-ruleForm">
						<el-form-item label="" prop="phone" label-width="0px">
							<div class="el-form-item-content">
								<el-input v-model="ruleForm.phone" maxlength="15" placeholder="请输入账号">
									<img slot="prefix" src="http://img-dbzd.doubaozhidao.com/20231109/1699497131753801.png" alt="账号" />
								</el-input>
							</div>
						</el-form-item>
						<el-form-item label="" prop="password"  label-width="0px">
							<div class="el-form-item-content">
								<el-input type="password" maxlength="18" v-model="ruleForm.password" placeholder="请输入密码">
									<img slot="prefix" src="http://img-dbzd.doubaozhidao.com/20231109/1699497162180069.png" alt="密码" />
								</el-input>
							</div>
						</el-form-item>
						<div class="login-form-item">
							<label class="item-label"><el-checkbox v-model="isRemPasFlag">记住密码</el-checkbox></label>
						</div>
						<div class="login-form-item" style="margin-top: 30px;">
							<el-button class="login-btn" type="primary" @click="submitForm('ruleForm')">登录</el-button>
						</div>
						<div class="login-form-item item-link">
							<a class="alink" target="_blank" href="https://web.xinda12.com/pages/teacher-my/teacher-register/teacher-register?utmSourse=mpg">立即入驻</a>
						</div>
						<div class="login-form-item">
							<label class="item-label"><el-checkbox v-model="isread">阅读并同意</el-checkbox></label>
							<a class="alink" href="javascript:;" @click="userAgreement">《豆包知道服务协议》</a>
						</div>
					</el-form>
				</div>
			</div>	
		</div>
	</div>
</template>
<script>
	import {mapActions, mapMutations } from 'vuex'
	export default {
		name: 'Login',
		data() {
			let validatePass = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入密码'))
				} else {
					callback();
				}
			};
			let validateUser = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入账号'))
				}  else if(value.length <6 || value.length > 15) {
					callback(new Error('账号为6-15位'))
				} else {
					callback();
				}
			};
			return {
				ruleForm: {
					phone: '',
					password: ''
				},
				rules: {
					phone: [{
						validator: validateUser,
						trigger: 'blur'
					}],
					password: [{
						validator: validatePass,
						trigger: 'blur'
					}]
				},
				isRemPasFlag: true,
				isread: true
			}
		},
		created() {
			if(localStorage.getItem('phone')) {
				this.ruleForm = {
					phone: localStorage.getItem('phone'),
					password: localStorage.getItem('password')
				}
			}
		},
		methods: {
			...mapMutations(['setIsShowMobile']),
			...mapActions('login', ['login', 'depositConfirmAPI']),
			submitForm(formName) {
				this.$refs[formName].validate(async (valid) => {
					if (valid) {
						if(!this.isread) {
							this.$message({
								type: 'error',
								message: '请勾选豆包知道服务协议'
							})
							return
						}
						let res = await this.login(this.ruleForm)
						localStorage.setItem('password', this.ruleForm.password)
						localStorage.setItem('phone', this.ruleForm.phone)
						localStorage.setItem('token', res.token)
						localStorage.setItem('name', res.name)
						localStorage.setItem('avatar_url', res.avatar_url)
						localStorage.setItem('desc', res.desc)
						localStorage.setItem('wx_url', res.wx_url)
						localStorage.setItem('bind_wx_url', res.wx_url)
						localStorage.setItem('isShow', 'yes')
						localStorage.setItem('institution', res.institution * 1)
						localStorage.setItem('activeFlag', 1)
						localStorage.setItem('id', res.id)
						localStorage.setItem('msgKey', '')
						localStorage.setItem('authorizeKey', '')
						this.setIsShowMobile(res.is_show_mobile)
						const routePath = this.$route.query.redirect?this.$route.query.redirect:this.staticPath
						localStorage.setItem('platPath',routePath)
						this.depositConfirmFn(1 ,routePath)
						this.setProtocolLog()
					} else {
						return false;
					}
				});
			},
			userAgreement() {
				window.open('/static/html/agreement.html')
			},
			// 扣除保证金协议警告
			async handleDepositWarn(routePath){
				let content = '您了解并确认，未经平台书面同意您不得直接或间接通过本平台以外的任何第三方渠道（如私域等）向本平台用户及消费者推销课程产品，由此产生的一切争议及纠纷，包括但不限于消费者投诉、退款申请等，均由您自行负责承担，与本平台无关。若您一旦违反本条款约定，本平台有权扣除您支付的保证金且不予结算任何款项，且本平台因此所遭受的损失亦可另行向您主张。'
				this.$confirm(content, '提示', {
					confirmButtonText: '我已认真阅读并确认',
					showClose: false,
					showCancelButton: false,
					closeOnClickModal: false
				})
				.then(() => {
					this.depositConfirmFn(2, routePath)
				})
			},
			// 记录 阅读并同意《豆包知道服务协议》日志
			async setProtocolLog(){
				let res = await this.depositConfirmAPI({
					type: 2, // 1查询 2签署
					agreement_id: 2 //  阅读并同意《豆包知道服务协议》
				})
				// console.log('setProtocolLog-res:',res)
			},
			// 获取同意状态 或者 同意协议 （那个保证金相关协议弹窗）
			async depositConfirmFn(type, routePath){ // type: 1=>查询是否签署协议, 2=>签署协议
				let goNextPage = ()=>{
					this.$router.push(routePath)
					this.$message({
						type: 'success',
						message: '登录成功',
						duration: 3000
					})
				}
				let res = await this.depositConfirmAPI({
					type: type,
					agreement_id: 1
				})
				if(type==1){
					if(!res.is_confirm){ // 未同意
						this.handleDepositWarn(routePath)
					}else{
						goNextPage()
					}
				}else{
					goNextPage()
				}
			}
		}
	}
</script>
<style lang="less">
	.login_content {
		.el-form-item {
			margin-bottom: 0;
			margin-top: 16px;
			.el-form-item__content {
				margin-left: 0;
			}
		}
		
		.el-checkbox__label {
			font-size: 14px;
			font-weight: 400;
			color: #fff;
			line-height: 14px;
		}
		.el-checkbox__input.is-checked+.el-checkbox__label{
			color: #fff;
		}
		.el-checkbox__inner{
			width: 20px;
			height: 20px;
			border-radius: 4px;
			border-color: transparent;
			&::after{
				height: 10px;
    			left: 8px;
			}
		}
		.el-form-item-content {
			.el-input__inner{
				background-color: transparent;
				border-top: 0;
				border-left: 0;
				border-right: 0;
				border-bottom: 1px solid #fff;
				border-radius: 0;

				color: #FFF;
				font-size: 18px;
				font-style: normal;
				font-weight: 600;
				line-height: normal;
				padding-left: 36px;
				// padding-top: 24px;
				padding-bottom: 16px;

				height: auto;
				&::placeholder {
					color: #FFF;
				}
			}
			.el-input__prefix, .el-input__suffix{
				color: #fff;
			}
			.el-input__prefix {
				img{
					width: 24px;
					height: 24px;
					margin-top: 4px;
				}
			}
			
		}
	}
</style>
<style lang="less" scoped>
	.user-login-index{
		background-color: #6788FF;
	}
	.content_right_con {
		background-color: transparent;
		box-shadow: none;
	}
	.login {
		width: 100vw;
		height: 100vh;
		min-width: 1200px;
		min-height: 598px;
		display: flex;
		justify-content: center;
		background: url('http://img-dbzd.doubaozhidao.com/20231108/1699439549053242.png') left top no-repeat;
		background-color: #6788FF;
		background-size: 1980px 1024px;
		box-sizing: border-box;
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;
		.login_content {
			margin: 0 auto;
			width: 1200px;
			height: 598px;
			display: flex;
			box-sizing: border-box;
			justify-content: space-between;
			.login_content_left {
				position: relative;
				width: 759px;
				height: 458px;
				background: url('https://img-dbzd.doubaozhidao.com/wisdomhtml/20241217_1709_loginBg.png') no-repeat left top;
				background-size: 759px 458px;
				.login-qr-service{
					position: absolute;
					bottom: 0;
					right: 46px;
					width: 196px;
					height: 200px;
					display: flex;
					justify-content: center;
					align-items: center;
					flex-direction: column;
					.qr-img{
						width: 102px;
						height: 102px;
						margin-bottom: 16px;
						margin-top: 40px;
					}
					.qr-text{
						color: #5671FD;
						font-family: PingFang SC;
						font-size: 12px;
						font-style: normal;
						font-weight: 500;
						line-height: normal;
					}
				}
			}
			.login_content_right {
				width: 375px;
				padding: 41px 0 10px;
				box-sizing: border-box;
				display: flex;
				flex-direction: column;
				align-items: center;
			}
			.login_content_header {
				.login_content_header_img {
					display: flex;
					align-items: center;
					justify-content: center;
					img {
						width: 160px;
						height: 37px;
					}
				}
				.login_content_header_tit {
					color: #fff;
					margin-top: 20px;
					margin-bottom: 20px;
					font-size: 22px;
					font-style: normal;
					font-weight: 600;
					line-height: normal;
				}
			}
			.el-form-item-content {
				width: 372px;
				margin-top: 0px;
			}
			.login-btn{
				width: 372px;
				height: 44px;
				border-radius: 50px;
				background: linear-gradient(180deg, #F1F4FE 0%, #F1F4FE 100%);
				box-shadow: 0px 4px 4px 0px #FFF inset, 0px 4px 4px 0px #7893F1;
				border: none;
				color: #4172FF;
				font-size: 20px;
				font-style: normal;
				font-weight: 500;
				line-height: 1;
				font-size: 18px;
			}
		}
		.login-form-item{
			margin-top: 16px;
			color: #fff;
			font-style: normal;
			font-weight: 400;
			font-size: 14px;
			.item-label {
				color: #fff;
				cursor: pointer;
			}
			.alink{
				color: #fff;
				text-decoration:none;
				&:hover{
					text-decoration: underline;
				}
			}
		}
		.item-link{
			text-align: center;
			color: #fff;
			font-size: 18px;
			text-align:center;
			font-weight: 600;
			margin-top: 30px;
			.alink{
				text-decoration:none;
				&:hover{
					text-decoration: none;
				}
			}
		}
	}

</style>
